import React, { useState, forwardRef, useImperativeHandle } from 'react';

import Box from '@material-ui/core/Box';
import Button from '@material-ui/core/Button';
import CircularProgress from '@material-ui/core/CircularProgress';
import Dialog from '@material-ui/core/Dialog';
import MuiDialogActions from '@material-ui/core/DialogActions';
import MuiDialogContent from '@material-ui/core/DialogContent';
import MuiDialogTitle from '@material-ui/core/DialogTitle';
import Divider from '@material-ui/core/Divider';
import IconButton from '@material-ui/core/IconButton';
import Paper from '@material-ui/core/Paper';
import Slide from '@material-ui/core/Slide';
import { withStyles, makeStyles } from '@material-ui/core/styles';
import Table from '@material-ui/core/Table';
import TableBody from '@material-ui/core/TableBody';
import TableCell from '@material-ui/core/TableCell';
import TableContainer from '@material-ui/core/TableContainer';
import TableHead from '@material-ui/core/TableHead';
import TableRow from '@material-ui/core/TableRow';
import Typography from '@material-ui/core/Typography';
import InventoryIcon from '@material-ui/icons/AddCircleTwoTone';
import CloseIcon from '@material-ui/icons/Close';
import { useSnackbar } from 'notistack';

import { getListAllAPI } from '../../../services';
import { TURNO_MANHA, TURNO_NOITE, TURNO_12_HORAS } from '../../../utils';

const styles = (theme) => ({
  root: {
    margin: 0,
    padding: theme.spacing(2),
  },
  closeButton: {
    position: 'absolute',
    right: theme.spacing(1),
    top: theme.spacing(1),
    color: 'white',
  },
});

const Transition = React.forwardRef((props, ref) => (
  <Slide direction="up" ref={ref} {...props} />
));

const DialogTitle = withStyles(styles)((props) => {
  const { children, classes, onClose, ...other } = props;
  return (
    <MuiDialogTitle disableTypography className={classes.root} {...other}>
      <Typography variant="h6" style={{ fontWeight: 'bold' }}>
        {children}
      </Typography>
      {onClose ? (
        <IconButton
          aria-label="close"
          className={classes.closeButton}
          onClick={onClose}
        >
          <CloseIcon />
        </IconButton>
      ) : null}
    </MuiDialogTitle>
  );
});

const DialogContent = withStyles((theme) => ({
  root: {
    padding: theme.spacing(2),
  },
}))(MuiDialogContent);

const DialogActions = withStyles((theme) => ({
  root: {
    margin: 0,
    padding: theme.spacing(1),
  },
}))(MuiDialogActions);

const useStyles = makeStyles((theme) => ({
  rootDialogo: {
    borderRadius: '25px',
  },
  btnAtions: {
    borderRadius: '25px',
    width: '150px',
  },
  campo: {
    display: 'flex',
    flexDirection: 'column',
  },
  label: {
    fontSize: '0.75rem',
    color: theme.palette.text.secondary,
  },
  valor: {
    fontSize: '1rem',
    fontWeight: 500,
  },
}));

const optionsTurno = {
  [TURNO_MANHA]: 'Manhã',
  [TURNO_NOITE]: 'Noite',
  [TURNO_12_HORAS]: '12H',
};

function Campo({ label, valor, classes }) {
  return (
    <Box className={classes.campo} flex={1}>
      <span className={classes.label}>{label}</span>
      <span className={classes.valor}>{valor || '-'}</span>
    </Box>
  );
}

const DialogoDetalhes = forwardRef(({ handleClose }, ref) => {
  const [open, setOpen] = useState(false);
  const { enqueueSnackbar } = useSnackbar();
  const [carregando, setCarregando] = useState(false);
  const [resource, setResource] = useState(null);

  const classes = useStyles();

  const handleCloseDialog = () => {
    setOpen(false);
    setResource(null);
    if (handleClose) handleClose();
  };

  async function getDataResource(id) {
    try {
      const data = await getListAllAPI(
        'codinomes_colaborador',
        ['id', 'asc'],
        { id: [id] },
        [
          'funcao',
          'grupoColaborador',
          'colaborador',
          'produtos.produto',
          'espelho.produtos.produto',
          'usadoComoEspelho',
        ],
      );
      if (data.data.length > 0) {
        setResource(data.data[0]);
        setCarregando(false);
      } else {
        throw 'Este Codinome não existe!';
      }
    } catch (erros) {
      enqueueSnackbar(`${erros}`, {
        variant: 'error',
      });
      handleCloseDialog();
    }
  }

  useImperativeHandle(ref, () => ({
    handleOpen(id) {
      setCarregando(true);
      setResource(null);
      setOpen(true);
      getDataResource(id);
    },
  }));

  const espelhoInfo = resource
    ? resource.usadoComoEspelho
      ? {
          label: 'Espelho',
          nome: resource.usadoComoEspelho.nome,
          ajuda: `Este codinome é usado como espelho pelo codinome "${resource.usadoComoEspelho.nome}".`,
        }
      : resource.espelho
      ? {
          label: 'Codinome Original (Manhã)',
          nome: resource.espelho.nome,
          ajuda: `Este codinome é um espelho do codinome "${resource.espelho.nome}".`,
        }
      : null
    : null;

  const produtos = resource
    ? resource.produtos && resource.produtos.length > 0
      ? resource.produtos.map((p) => p.produto).filter(Boolean)
      : resource.espelho && resource.espelho.produtos
      ? resource.espelho.produtos.map((p) => p.produto).filter(Boolean)
      : []
    : [];

  return (
    <Dialog
      open={open}
      aria-labelledby="detalhes-dialog-title"
      classes={{ paper: classes.rootDialogo }}
      className={classes.rootDialogo}
      fullWidth
      maxWidth="md"
      TransitionComponent={Transition}
      keepMounted
    >
      <DialogTitle
        id="detalhes-dialog-title"
        onClose={handleCloseDialog}
        style={{ backgroundColor: '#009FD4', color: 'white' }}
      >
        Detalhes do Codinome
      </DialogTitle>
      <DialogContent
        style={{
          padding: '0px 36px 20px',
          margin: '0',
        }}
      >
        {carregando || !resource ? (
          <div
            style={{
              display: 'flex',
              justifyContent: 'center',
              alignItems: 'center',
              minHeight: '200px',
            }}
          >
            <CircularProgress />
          </div>
        ) : (
          <div>
            <Box display="flex" mt="1em">
              <Campo label="Descrição" valor={resource.nome} classes={classes} />
              <Campo
                label="Função"
                valor={resource.funcao ? resource.funcao.nome : ''}
                classes={classes}
              />
            </Box>
            <Box display="flex" mt="1em">
              <Campo
                label="Grupo"
                valor={resource.grupoColaborador ? resource.grupoColaborador.nome : ''}
                classes={classes}
              />
              <Campo
                label="Turno"
                valor={optionsTurno[resource.turno]}
                classes={classes}
              />
            </Box>
            <Box display="flex" mt="1em">
              <Campo
                label="Em uso"
                valor={resource.usado ? 'Sim' : 'Não'}
                classes={classes}
              />
              <Campo
                label="Colaborador"
                valor={resource.colaborador ? resource.colaborador.nome : ''}
                classes={classes}
              />
            </Box>

            <Divider style={{ margin: '20px 0' }} />

            <Typography variant="subtitle1" style={{ fontWeight: 'bold' }}>
              Espelho
            </Typography>
            <Box mt="0.5em">
              {espelhoInfo ? (
                <>
                  <Campo
                    label={espelhoInfo.label}
                    valor={espelhoInfo.nome}
                    classes={classes}
                  />
                  <Typography
                    variant="body2"
                    color="textSecondary"
                    style={{ marginTop: '4px' }}
                  >
                    {espelhoInfo.ajuda}
                  </Typography>
                </>
              ) : (
                <Typography variant="body2" color="textSecondary">
                  Nenhum espelho vinculado a este codinome.
                </Typography>
              )}
            </Box>

            <Divider style={{ margin: '20px 0' }} />

            <Box
              display="flex"
              alignItems="center"
              justifyContent="space-between"
            >
              <Typography variant="subtitle1" style={{ fontWeight: 'bold' }}>
                Produtos ({produtos.length})
              </Typography>
            </Box>
            {produtos.length > 0 ? (
              <TableContainer
                component={Paper}
                variant="outlined"
                style={{ marginTop: '12px' }}
              >
                <Table size="small">
                  <TableHead>
                    <TableRow style={{ backgroundColor: '#f5f5f5' }}>
                      <TableCell style={{ fontWeight: 'bold', width: '100px' }}>
                        ID
                      </TableCell>
                      <TableCell style={{ fontWeight: 'bold' }}>Nome</TableCell>
                    </TableRow>
                  </TableHead>
                  <TableBody>
                    {produtos.map((produto) => (
                      <TableRow key={produto.id} hover>
                        <TableCell>{produto.id}</TableCell>
                        <TableCell>{produto.nome}</TableCell>
                      </TableRow>
                    ))}
                  </TableBody>
                </Table>
              </TableContainer>
            ) : (
              <Box
                display="flex"
                flexDirection="column"
                alignItems="center"
                justifyContent="center"
                color="text.secondary"
                mt="1em"
                mb="1em"
              >
                <InventoryIcon style={{ fontSize: 48, opacity: 0.4 }} />
                <Typography variant="body2" style={{ marginTop: '8px' }}>
                  Nenhum produto associado a este codinome
                </Typography>
              </Box>
            )}
          </div>
        )}
      </DialogContent>
      <DialogActions
        style={{
          padding: '0px 36px 20px',
          margin: '0',
        }}
      >
        <Button
          onClick={handleCloseDialog}
          classes={{ root: classes.btnAtions }}
          variant="contained"
          color="primary"
        >
          Fechar
        </Button>
      </DialogActions>
    </Dialog>
  );
});

export default DialogoDetalhes;
